import Vue from 'vue'

import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';

const roundPercent = Symbol('roundPercent');

const parallaxClass = new class Parallax {

    constructor() {
        // console.log(`${this.constructor.name}:init`)

        this.pos, this.lastPos = {};

        this.items = {}
        this.activeItems = []

        // Define observer
        let $target
        this.observer = new IntersectionObserver($observables => {
            this.lastPos = {}
            $observables.forEach(($observable) => {
                $target = $observable.target
                if ($observable.isIntersecting) {
                    this.activeItems.push($target.id)
                } else {
                    this.activeItems = this.activeItems.filter(i => i !== $target.id)
                }
            })
        });

        // Window events
        window.addEventListener('load', () => {

            this.container = document.body

            // Scroll in page
            this.scroll = {
                x: window.pageYOffset,
                y: this.container.scrollLeft
            }

            // Set sizes
            this.setSizes()

            // RAF Loop
            window.requestAnimationFrame(this.loop.bind(this))
        })

        window.addEventListener('resize', this.setSizes.bind(this))
    }

    setSizes() {
        // console.log(`${this.constructor.name}:setSizes`)

        this.W = {
            w: window.innerWidth,
            h: window.innerHeight,
        }

        this.doc = {
            h: window.document.documentElement.scrollHeight,
            w: this.container.scrollWidth,
        }
    }

    observeItem(id, item) {
        // console.log(`${this.constructor.name}:observeItem`)
        this.items[id] = item
        this.observer.observe(this.items[id].element)
    }

    unobserveItem(id) {
        // console.log(`${this.constructor.name}:unobserveItem`, id)
        this.observer.unobserve(this.items[id].element)
        delete this.items[id]
        this.activeItems = this.activeItems.filter(i => i !== id)
    }

    loop() {
        // console.log(`${this.constructor.name}:loop`)

        this.pos = {
            top: window.pageYOffset,
            right: this.container.scrollLeft + this.W.w,
            bottom: window.pageYOffset + this.W.h,
            left: this.container.scrollLeft,
        }

        if(isEqual(this.pos, this.lastPos)) {
            requestAnimationFrame(this.loop.bind(this));
            return;
        } else {
            this.lastPos = this.pos;
        }


        let i, inType, eventType;
        this.activeItems.forEach(id => {
            i = this.items[id]

            let distance = this.getInType(i)

            TweenLite.to(i.element, .2, {
                x: distance * i.dept.x,
                y: distance * i.dept.y,
            })
        })

        this.scroll = {
            x: this.pos.top,
            y: this.pos.left,
        };


        requestAnimationFrame(this.loop.bind(this))
    }

    getInType(i) {
        let rect = i.element.getBoundingClientRect();
        let elementTop = rect.top + this.pos.top;
        // let elementLeft = rect.left + this.pos.left;
        // let elementBottom = elementTop + rect.height;
        // let topIn = elementTop > this.pos.top && elementTop < this.pos.bottom;
        // let bottomIn = elementBottom > this.pos.top && elementBottom < this.pos.bottom;
        // let percentInParallax = topIn || bottomIn ? ((bottomIn ? elementBottom : this.pos.bottom) - (topIn ? elementTop : this.pos.top)) / rect.height : 0;
        // let centerPercentY = (elementTop - this.pos.top + rect.height / 2) / this.W.h;
        // let centerPercentX = (elementLeft - this.pos.left + rect.width / 2) / this.W.w;
        let zeroPoint = {
            top: this.pos.top - rect.height,
            left: this.pos.left - rect.width
        }
        let topPercent = (elementTop - zeroPoint.top) / (this.pos.bottom - zeroPoint.top);
        let distance = (1 - this[roundPercent](topPercent)) * 100
        // let leftPercent = (elementLeft - zeroPoint.left) / (this.pos.right - zeroPoint.left);

        return distance
    }

    [roundPercent](v) {
        return (v * 1000 | 0) / 1000
    }
}


let itemIndex = 0
export const parallax = Vue.directive('parallax', {
    unbind: function($el, bind) {
        delete parallax.items[$el.id]
    },
    inserted: function($el, bind) {
        let id = $el.id || ('parallax-id-' + itemIndex++)
        let item = parallaxClass.items[id] || { element: $el, rect: {} }


        if (typeof bind.value === 'number') {
            item.dept = {
                x: 0,
                y: bind.value
            }
        } else if(typeof bind.value === 'object') {
            item.dept = {
                x: bind.value.x,
                y: bind.value.y
            }
        } else {
            item.dept = {
                x: 0,
                y: 0
            }
        }

        $el.id = id

        parallaxClass.observeItem(id, item)
    },
    unbind: function($el, bind) {
        parallaxClass.unobserveItem($el.id)
    }
})
